import { render, staticRenderFns } from "./office-profiles-edit.vue?vue&type=template&id=2f2f38fb&scoped=true&lang=pug"
import script from "./office-profiles-edit.vue?vue&type=script&lang=ts"
export * from "./office-profiles-edit.vue?vue&type=script&lang=ts"
import style0 from "./office-profiles-edit.vue?vue&type=style&index=0&id=2f2f38fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f38fb",
  null
  
)

export default component.exports